import React from 'react';
import DataTable from 'components/Table/DataTable';

const columns = [
    {
        name: "Reference",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Total Cost to Cellfind",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Total Price for Customer",
        options: {
            filter: true,
            sort: true,
        }
    }
];



class TotalCostPriceTable extends React.Component {

    render() {
        return (
                <DataTable
                    title={"Cost/Price Details"}
                    data={
                        this.props.data
                        .map(stat => 
                            [
                                stat.product_reference,
                                stat.total_cost,
                                stat.total_price
                            ]
                        )
                    }
                    columns={columns}
                />
        );
    }
}

export default TotalCostPriceTable;
